import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';

import { CustomSearchComponent } from '@connect-services/client/components/custom-search/custom-search.component';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, CustomSearchComponent, RessourcesModule],
    selector: 'app-management-list-header',
    templateUrl: './management-list-header.component.html',
})
export class ManagementListHeaderComponent {
    public actionClicked: OutputEmitterRef<void> = output<void>();
    public readonly actionEnabled: InputSignal<boolean> = input<boolean>(false);
    public readonly asAction: InputSignal<boolean> = input<boolean>(true);
    public readonly asSearch: InputSignal<boolean> = input<boolean>(true);
    public search: OutputEmitterRef<string> = output<string>();
    public readonly searchValue = input<string>('');
    public readonly subtitle: InputSignal<string | undefined> = input<string>();
    public readonly title: InputSignal<string> = input.required<string>();

    protected readonly ButtonType = ButtonType;
}
